import type { MarkerCircleProps } from "./marker-circle.type";

import { Typography } from "antd";

import { scaleMarkerCircleSize } from "./marker-circle.helper";

import "./marker-circle.style.less";

const { Text } = Typography;

const MarkerCircle = ({ color, scale, content }: MarkerCircleProps) => {
  const { width, height, mainRadius, smallRadius } =
    scaleMarkerCircleSize(scale);

  return (
    <div className="marker-circle" style={{ width, height }}>
      <svg
        viewBox={`0 0 ${width} ${height}`}
        width={width}
        height={height}
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle fill="#fff" cx={mainRadius} cy={mainRadius} r={mainRadius} />
        <circle
          fill={color ?? "#2C40DE"}
          cx={mainRadius}
          cy={mainRadius}
          r={smallRadius}
        />
      </svg>
      {content ? (
        <div className="marker-circle-content">
          <Text>{content}</Text>
        </div>
      ) : null}
    </div>
  );
};

export default MarkerCircle;
